export default ($t) => ({
  title: "NotifyTeamLeadersOnEachDonation",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      extended: true,
      default: false,
    },
    allow_team_leader_respond: {
      title: $t(
        "edit_campaign.schema_notify_team_leaders_on_each_donation_allow_team_leader_respond",
        "Allow team leader respond"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_notify_team_leaders_on_each_donation_allow_team_leader_respond_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    skip_offline_donations: {
      title: $t(
        "edit_campaign.schema_notify_team_leaders_on_each_donation_skip_offline_donations",
        "Skip offline donations"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_notify_team_leaders_on_each_donation_skip_offline_donations_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    template_id: {
      title: $t(
        "edit_campaign.schema_notify_team_leaders_on_each_donation_template_id",
        "Template Id"
      ),
      type: "number",
      default: 0,
      description: $t("schema_notify_team_leaders_on_each_donation_template_id_description", {
        returnEmptyOnMissing: true,
      }),
    },
  },
});
